import { render } from "./WebsitePackagesSection.vue?vue&type=template&id=2efb7fca&scoped=true"
import script from "./WebsitePackagesSection.vue?vue&type=script&lang=js"
export * from "./WebsitePackagesSection.vue?vue&type=script&lang=js"

import "./WebsitePackagesSection.vue?vue&type=style&index=0&id=2efb7fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efb7fca"]])

export default __exports__